import { Injectable } from '@angular/core';
import { ActionSheetController, AlertController, Platform, ToastController } from '@ionic/angular';



@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private actionSheetController: ActionSheetController,
    private platform: Platform) { }

  // Messages
  async genericMessageBox(title: string, message: string, cb?: () => void) {
    const msgbox = await this.alertCtrl.create({
      header: title,
      message: message,
      cssClass: 'messageBox',
      mode: 'ios',
      buttons: [{text: 'OK', handler: cb}]
    });
    await msgbox.present();
  }

  async textAreaMessageBox(title: string, message: string, cb?: () => void) {
    const msgbox = await this.alertCtrl.create({
      header: title,
      inputs: [
        {
          type: 'textarea',
          value: message,
        }
      ],
      cssClass: 'messageBox',
      mode: 'ios',
      buttons: [{text: 'OK', handler: cb}]
    });
    await msgbox.present();
  }

  // Messages
  async xxx(title: string, message: string, cb?: () => void) {
    const msgbox = await this.alertCtrl.create({
      header: title,
      inputs: [
        {
          name: 'paragraph',
          id: 'paragraph',
          type: 'textarea',
          cssClass: 'textareaBox',
          value: message
        },
      ],
      cssClass: 'messageBox',
      mode: 'ios',
      buttons: [{text: 'OK', handler: cb}]
    });
    await msgbox.present();
  }

  async msgboxConfirm(title: string, message: string, cb?: () => void, cb2?: () => void) {
    const msgbox  = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {text: "Cancel", role: 'cancel', cssClass: 'secondary', handler: cb2},
        {text: 'Ok', handler: cb}
      ]
    });
    await msgbox.present();
  }

  async msgPop(msgParam: string, color = 'primary', popDuration = 3000, popPosition: 'bottom'|'top'|'middle' = 'bottom') {
    const toast = await this.toastCtrl.create({
      message: msgParam,
      duration: popDuration,
      position: popPosition,
      color: color
    });
    toast.present();
  }

 
  today() {
    let date = new Date();
    let isoDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
    return isoDate.slice(0, -1) + '+08:00';
  }

  getDateOnly(date: string) {
    return date.substring(0,10);
  }

  getDateLocale(date: string) {
    return new Date(date).toLocaleString('en-my');
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  
  ionSelectRefresh(control: any) {
    let value = control.value;
    control.reset();
    control.setValue(value);
  }

 
}
